// extracted by mini-css-extract-plugin
export default {"container":"DeleteHistoryIcon_container__hZ7VX"};